'use client'

import React from 'react'
import HeaderFinal from '../components/HeaderFinal'
import Footer from '../components/Footer'

const ComoLlegarPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-900 via-purple-900 to-black text-white">
      <HeaderFinal />
      
      {/* Hero Section */}
      <div className="relative pt-24 pb-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              CÓMO LLEGAR A AIRLOVERS
            </h1>
            <p className="text-xl text-white/80 max-w-3xl mx-auto">
              Ubicados frente al Embalse del Tominé, a solo 45 minutos al norte de Bogotá
            </p>
          </div>

          {/* Información principal */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            {/* Mapa y ubicación */}
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
              <h2 className="text-3xl font-bold mb-6">📍 UBICACIÓN EXACTA</h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold mb-3 text-blue-300">🏔️ DIRECCIÓN:</h3>
                  <p className="text-lg">Frente al Embalse del Tominé, Tocancipá, Cundinamarca</p>
                  <p className="text-white/70 mt-2">45 minutos al norte de Bogotá • 20 minutos desde Tocancipá por vía rural</p>
                </div>
                
                <div>
                  <h3 className="text-xl font-bold mb-3 text-blue-300">🗺️ COORDENADAS:</h3>
                  <p className="text-lg">4°57'N 73°54'W</p>
                  <p className="text-white/70 mt-2">Coordenadas exactas para GPS y navegación</p>
                </div>
                
                <div>
                  <h3 className="text-xl font-bold mb-3 text-blue-300">🚗 ACCESO POR WAZE:</h3>
                  <a 
                    href="https://waze.com/ul/hd2gkn61x6" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl font-bold hover:shadow-xl transition-all duration-300"
                  >
                    <span className="mr-3">🗺️</span>
                    ABRIR EN WAZE
                  </a>
                  <p className="text-white/70 mt-2">Link preciso que lleva directamente a nuestra ubicación</p>
                </div>
              </div>
            </div>

            {/* Horarios y transporte */}
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
              <h2 className="text-3xl font-bold mb-6">🕑 HORARIOS DE ATENCIÓN</h2>
              <div className="space-y-8">
                <div>
                  <h3 className="text-xl font-bold mb-3 text-green-300">📅 DÍAS HÁBILES:</h3>
                  <div className="bg-black/30 rounded-xl p-4">
                    <p className="text-lg font-bold">Lunes a viernes:</p>
                    <p className="text-2xl font-bold text-green-400">10:00 AM - 5:00 PM</p>
                  </div>
                </div>
                
                <div>
                  <h3 className="text-xl font-bold mb-3 text-yellow-300">🎉 FINES DE SEMANA Y FESTIVOS:</h3>
                  <div className="bg-black/30 rounded-xl p-4">
                    <p className="text-lg font-bold">Sábados, domingos y festivos:</p>
                    <p className="text-2xl font-bold text-yellow-400">9:00 AM - 5:30 PM</p>
                  </div>
                </div>
                
                <div className="bg-gradient-to-r from-blue-900/40 to-purple-900/40 rounded-xl p-6 border border-blue-500/30">
                  <h3 className="text-xl font-bold mb-3">⚠️ RECOMENDACIÓN IMPORTANTE:</h3>
                  <p className="text-lg">
                    <span className="font-bold text-blue-300">El vuelo depende 100% del clima.</span> Recomendamos llegar temprano para aprovechar las mejores condiciones de vuelo.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Instrucciones detalladas */}
          <div className="max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
              <h2 className="text-3xl font-bold mb-8">🚗 INSTRUCCIONES DETALLADAS</h2>
              
              <div className="space-y-8">
                {/* Desde Bogotá */}
                <div>
                  <h3 className="text-2xl font-bold mb-4 text-blue-300">DESDE BOGOTÁ:</h3>
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-4 flex-shrink-0">1</div>
                      <div>
                        <p className="text-lg font-bold">Toma la Autopista Norte hacia Chía</p>
                        <p className="text-white/70">Sigue por la Autopista Norte (Autopista Norte - Calle 80)</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start">
                      <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-4 flex-shrink-0">2</div>
                      <div>
                        <p className="text-lg font-bold">Continúa hacia Tocancipá</p>
                        <p className="text-white/70">Pasa por Chía, Cajicá y Zipaquirá</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start">
                      <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-4 flex-shrink-0">3</div>
                      <div>
                        <p className="text-lg font-bold">Toma la vía rural hacia el Embalse del Tominé</p>
                        <p className="text-white/70">Sigue las indicaciones hacia el embalse</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start">
                      <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-4 flex-shrink-0">4</div>
                      <div>
                        <p className="text-lg font-bold">Llegada a Airlovers</p>
                        <p className="text-white/70">Ubicados frente al embalse, con vista panorámica</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Recomendaciones */}
                <div className="bg-gradient-to-r from-purple-900/30 to-pink-900/30 rounded-xl p-6 border border-purple-500/30">
                  <h3 className="text-xl font-bold mb-4">💡 RECOMENDACIONES PARA TU VISITA:</h3>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <span className="text-green-400 mr-2">✓</span>
                      <span>Usa <span className="font-bold">WAZE</span> para navegación precisa</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-green-400 mr-2">✓</span>
                      <span>Lleva ropa cómoda y zapatos cerrados</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-green-400 mr-2">✓</span>
                      <span>Protector solar y gafas de sol recomendados</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-green-400 mr-2">✓</span>
                      <span>Disponibilidad de tiempo todo el día (clima dependiente)</span>
                    </li>
                  </ul>
                </div>

                {/* Contacto */}
                <div className="text-center pt-8 border-t border-white/20">
                  <h3 className="text-2xl font-bold mb-6">📱 ¿NECESITAS AYUDA?</h3>
                  <p className="text-white/80 mb-6">
                    Si tienes problemas para llegar o necesitas indicaciones adicionales
                  </p>
                  <a
                    href="https://wa.me/573028309637?text=¡Hola!%20Necesito%20ayuda%20para%20llegar%20a%20Airlovers"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-2xl font-bold hover:shadow-2xl transition-all duration-300"
                  >
                    <svg className="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981z"/>
                    </svg>
                    CONTACTAR POR WHATSAPP
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default ComoLlegarPage